import { useEffect, useState } from "react";
import { api } from "../lib/api";
import VideoCard from "./VideoCard";
import VerifyFaceBanner from "../components/VerifyFaceBanner";

export default function Feed() {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);

    const load = async () => {
        try {
            const { data } = await api.get("/videos/feed?limit=30");
            setVideos(data);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { load(); }, []);

    if (loading) return (
        <div className="min-h-[100dvh] flex flex-col">
            <div className="p-3"><VerifyFaceBanner compact /></div>
            <div className="flex-1 flex items-center justify-center text-wta-muted">Loading feed...</div>
        </div>
    );

    if (videos.length === 0) {
        return (
            <div className="min-h-[100dvh] flex flex-col">
                <div className="p-3"><VerifyFaceBanner compact /></div>
                <div className="flex-1 flex flex-col items-center justify-center text-center px-6">
                    <div className="font-heading text-5xl tracking-tight">No videos yet</div>
                    <p className="text-wta-muted mt-3 max-w-md">Be the first to post. Head over to <span className="text-wta-primary">Upload</span> and drop your best moment.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="relative">
            <div className="absolute top-3 left-1/2 -translate-x-1/2 z-30 w-[92%] max-w-xl pointer-events-auto">
                <VerifyFaceBanner compact />
            </div>
            <div className="snap-feed bg-black">
                {videos.map((v) => (
                    <VideoCard key={v.id} video={v} onChange={load} />
                ))}
            </div>
        </div>
    );
}
